export default __webpack_public_path__ + "static/blog2-5cc826aeaba54552ddc9fab8d22ca838.jpg";